import { useState, useEffect } from 'react';
import { Eye, EyeOff, Check, X } from 'lucide-react';

export default function PasswordInput({
  value,
  onChange,
  onValidityChange,
  placeholder = "كلمة المرور",
  id = "password",
  showValidator = true,
  className = ""
}) {
  const [showPassword, setShowPassword] = useState(false);

  const checks = {
    length: value.length >= 8,
    englishOnly: /^[A-Za-z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-]*$/.test(value) && value.length > 0,
    lettersAndNumbers: /[A-Za-z]/.test(value) && /[0-9]/.test(value),
    hasUppercase: /[A-Z]/.test(value),
  };

  const isValid = checks.length && checks.englishOnly && checks.lettersAndNumbers && checks.hasUppercase;

  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid, onValidityChange]);

  return (
    <div className="w-full">
      <div className="relative group">
        <input
          id={id}
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          className={`w-full bg-slate-50 dark:bg-[#0f0f0f] border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white px-4 py-3.5 rounded-xl focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-all font-sans ${className}`}
          placeholder={placeholder}
          dir="ltr"
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-primary-500 transition-colors"
        >
          {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
        </button>
      </div>

      {showValidator && value.length > 0 && (
        <div className="mt-3 p-4 bg-slate-50 dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-xl space-y-2.5 animate-in fade-in slide-in-from-top-2 duration-300">
          <ValidationItem isValid={checks.length} text="يجب ألا تقل عن 8 حروف" />
          <ValidationItem isValid={checks.englishOnly} text="يجب أن تكون باللغة الإنجليزية" />
          <ValidationItem isValid={checks.lettersAndNumbers} text="يجب أن تحتوي على حروف وأرقام" />
          <ValidationItem isValid={checks.hasUppercase} text="يجب أن تحتوي على حرف كبير (Capital)" />
        </div>
      )}
    </div>
  );
}

function ValidationItem({ isValid, text }) {
  return (
    <div className={`flex items-center gap-2 text-md font-medium transition-colors duration-300 ${isValid ? 'text-emerald-500' : 'text-slate-500 dark:text-zinc-500'}`}>
      <div className={`w-4 h-4 rounded-full flex items-center justify-center shrink-0 transition-colors duration-300 ${isValid ? 'bg-emerald-500 text-white' : 'bg-slate-200 dark:bg-zinc-800 text-transparent'}`}>
        <Check className="w-3 h-3" strokeWidth={3} />
      </div>
      <span>{text}</span>
    </div>
  );
}
